import { buildBranches, buildBrands, buildCategories } from "../../../repositories/filterActions"
import router from "../../../router"

const initialState = {
    filters: {
      options:{
        categories: null,
        brands: null,
        branches: null
      },
      selected: {
        sortBy: 'rel',
        initiator: null,
        categories: null,
        brands: null,
        branches: null,
        promoOnly: false,
        promoProducts: []
      },
      subSearch: ''
    },
}

export const filterStore = {
  state: {...initialState},
  mutations:{
    // Reset
    resetState(state){
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    // modify state provided
    setFilters(state, data){
      state.filters.selected.initiator = null
      state.filters.options.brands = buildBrands(data.products)
      state.filters.options.categories = buildCategories(data.products)
      state.filters.options.branches = buildBranches()
      // state.filters.selected.sortBy = router.currentRoute.value.query?.action == 'reorderPad' ? 'last-ordered' : router.currentRoute.value.query?.query ? 'rel' : 'desc-asc'
      state.filters.selected.sortBy = router.currentRoute.value.query?.query ? 'rel' : 'desc-asc'
      state.filters.selected.categories = null
      state.filters.selected.brands = null
      state.filters.selected.branches = null
      state.filters.selected.promoOnly = false
      state.filters.selected.promoProducts = data.promo_products
    },
    updateFilters(state, data){
      // Set Inititiator used for removal of menu options based on parent filter
      if(!state.filters.selected.initiator && data.action != 'branchFilter') state.filters.selected.initiator = data.action
      // Set filter selections
      if(data.action == 'promoProducts') state.filters.selected.promoOnly = data.promoOnly
      if(data.action == 'brandFilter') state.filters.selected.brands = data.brands
      if(data.action == 'categoryFilter') state.filters.selected.categories = data.categories
      if(data.action == 'branchFilter') state.filters.selected.branches = data.mode ? {mode: data.mode, branchList: data.branches} : null
      // If no filters applied remove initiator   
      if(!state.filters.selected.brands && !state.filters.selected.categories) state.filters.selected.initiator = null
    },
    setSubSearch(state, query){
      state.filters.subSearch = query
    },
    sortProducts(state, view){
      state.filters.selected.sortBy = view
    }
  },
  actions:{
    setFilters(context, data){
      context.commit('setFilters', data)
    },
    updateFilters(context, data){
      context.commit('updateFilters', data)
    },
    setSubSearch(context, query){
      context.commit('setSubSearch', query)
    },
    sortProducts(context, view){
      context.commit('sortProducts', view)
    }
  },
  getters:{
    productFilters: state => {return state.filters},
    subSearch: state => {return state.filters.subSearch}
  }
}